// src/utils/formatLastUpdated.js

/**
 * Fungsi untuk memformat waktu terakhir update menjadi format yang lebih mudah dibaca
 * @param {Date} date - Tanggal yang akan diformat
 * @returns {string} - String yang diformat
 */
export const formatLastUpdated = (date) => {
    if (!date) return '-';
    
    const now = new Date();
    const diffMs = now - date;
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMs / 3600000);
    const diffDays = Math.floor(diffMs / 86400000);
    
    if (diffMins < 1) {
        return 'Baru saja';
    } else if (diffMins < 60) {
        return `${diffMins} menit yang lalu`;
    } else if (diffHours < 24) {
        return `${diffHours} jam yang lalu`;
    } else if (diffDays < 7) {
        return `${diffDays} hari yang lalu`;
    } else {
        // Format tanggal lengkap
        return date.toLocaleDateString('id-ID', {
            day: 'numeric',
            month: 'short',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    }
};

export default formatLastUpdated;